const state = {
  country: {},
  countries: []
}

const getters = {
  country (state) {
    return state.country
  },
  countries (state) {
    return state.countries
  }
}

const mutations = {
  SET_COUNTRY (state, payload) {
    state.country = payload
  },
  SET_COUNTRIES (state, payload) {
    state.countries = payload
  }
}

const actions = {
  SET_COUNTRY (context, payload) {
    context.commit('SET_COUNTRY', payload)
  },
  SET_COUNTRIES (context, payload) {
    context.commit('SET_COUNTRIES', payload)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
